export const chunk = <T>(arr: readonly T[], len: number): T[][] => {
  const chunks: T[][] = []
  for (let i = 0; i < arr.length; i += len) {
    chunks.push(arr.slice(i, i + len))
  }
  return chunks
}
